import React from 'react'
import { DeleteProfile as DeleteUserAccount } from 'sharedComponents/DeleteProfile'
import { Box } from 'components/Layout'
import { COLOR } from 'theme'
import { Text } from 'components/Typography'

export const DeleteProfile = () => (
  <>
    <Box mb="1rem">
      <Text color={COLOR.grayDark}>This action is not reversible</Text>
    </Box>
    <DeleteUserAccount />
  </>
)
